import { Trans } from "i18n";
import { ReactComponent as TagTapesLogo } from "component-library/src/images/tagmin/tag-tapes-logo.svg";
import { getTagminSelfTapeUrl } from "pages/SelfTapeRequestPage/SelfTapeRequestAgentParts/helpers";

const TagTapesBanner = () => {
  return (
    <div className="flex items-start gap-1.5 p-2.5 bg-tagmin-bg border border-t-[5px] border-tagmin-primary rounded">
      <p className="text-s">
        <Trans
          i18nKey="common:selfTapes.request.sendToClient.tagTapesBanner.text"
          components={{
            a: (
              <a
                href={getTagminSelfTapeUrl()}
                target="_blank"
                rel="noopener noreferrer"
                title="Add TagTapes link"
              />
            ),
          }}
        />
      </p>
      <div>
        <TagTapesLogo height={40} />
      </div>
    </div>
  );
};

export default TagTapesBanner;
